
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {inspectionOrderApi} from "@/api/inspection";
    import EmptyContent from "@/components/EmptyContent.vue";
    import {instrumentApi} from "@/api/instrument";
    import {rulesApi} from "@/api/rules";
    import baseUrl, {uploadPage, imageUrl} from "../../constants";
    import {fileApi} from "@/api/organization";
    import guid from "@/common/guid";

    @Component({
        name: "inspectionDetail",
        components: {EmptyContent}
    })
    export default class Home extends Vue {
        title = "申请检定器具列表";
        id = "0";   //id
        listData = [];  //详情返回数据
        instruments = []; //器具列表
        departs = []; //检定单位列表
        departId = ""; //当前选中单位
        examineNumDialog = false;
        examineNumList = [];
        recordNumDialog = false;
        recordNumList = [];
        load = false;
        private closePage: any;
        allSelected = [];
        allSelectedExamine = [];
        orderApplyId = "0";

        addExamineDialog = false; //添加检测
        instrumentsId = 0; //选择的器具
        form2 = {} as any;
        form2Origin = {
            certificationNumber: "",   //证书编号
            certificateType: "",       //证书类型
            inspectionDate: "",        //检定日期
            expireDate: "",            //有效期
            checkCocn: "",             //检定结论
            checkResult: 1,           //检定状态
            resultText: "",                //检定结果
            basedRuleId: "",           //检定依据
            basedRuleName: "",         //检定依据名称
            reason: "",                //不合格原因
            checkPersonId: "",         //检定员id
            checkPersonName: "",       //检定员姓名
            checkPersonCardCode: "",   //检定员身份证号
            reApproverId: "",          //核验员id
            reApproverName: "",        //核验员姓名
            reApproverCardCode: "",    //核验员身份证号
            approverId: "",            //批准人id
            approverName: "",          //批准人名称
            approverCardCode: "",      //批准人身份证号
            enclosure: "",  //影印件
        }
        validCheckResult = (rule: any, value: any, cb: any) => {
            if(value != '0' || value != 0) {
                cb();
            }else{
                cb(new Error('请选择检定状态'));
            }
        }
        rules2 = {
            certificationNumber: [{ required: true, message: '请输入证书编号', trigger: 'blur' }],
            certificateType: [{ required: true, message: '请输入证书类型', trigger: 'change' }],
            inspectionDate: [{ required: true, message: '请输入检定日期', trigger: 'blur' }],
            expireDate: [{ required: true, message: '请输入有效期至', trigger: 'blur' }],
            checkCocn: [{ required: true, message: '请输入检定结论', trigger: 'blur' }],
            checkResult: [{trigger: 'change', validator: this.validCheckResult}],
            resultText: [{ required: true, message: '请输入检定结果', trigger: 'blur' }],
            basedRuleId: [{ required: true, message: '请输入检定依据', trigger: 'change' }],
            // checkPersonId: [{ required: true, message: '请输入检定人员', trigger: 'change' }],
            // reApproverId: [{ required: true, message: '请输入核验人员', trigger: 'change' }],
            // approverId: [{ required: true, message: '请输入批准人员', trigger: 'change' }],
            checkPersonName: [{ required: true, message: '请输入检定人员', trigger: 'blur' }],
            reApproverName: [{ required: true, message: '请输入核验人员', trigger: 'blur' }],
            approverName: [{ required: true, message: '请输入批准人员', trigger: 'blur' }],
            enclosure: [{ required: true, message: '请上传检定结果复印件', trigger: 'change' }],
        }
        measuringRules = [] as any //规程规范
        measuringRulesFilterd = [] as any //过滤后的规程规范

        //上传检定结果复印件
        baseUrl = baseUrl
        headers = {Authorization: ""}
        fileList = [] as any;
        imgGuid = guid()

        created() {
            this.init();
            this.getRules();
        }
        init(){
            this.id = this.$route.params.id;
            this.orderApplyId = this.$route.params.orderApplyId;
            this.getDetail();
        }

        showExamineList(row: any){
            this.instrumentsId = row.instrumentId?row.instrumentId:row.id;
            this.showExamineList2();
        }
        showExamineList2(){
            inspectionOrderApi.listOrderByInstrumentId({instrumentsId: this.instrumentsId}).then(r=>{
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.examineNumList = rData;
                    this.examineNumDialog = true;
                }
            })
        }
        showRecordList(row: any){
            instrumentApi.getAuditDetails({id: row.instrumentId}).then(r=>{
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.recordNumList = rData;
                    this.recordNumDialog = true;
                    this.$nextTick(() => {
                        let $table = this.$refs.recordNumTable as HTMLFormElement;
                        if ($table) {
                            $table.doLayout();
                        }
                    })
                }
            })
        }

        //获取器具详情
        getDetail(){
            inspectionOrderApi.listOrderDetails({orderId:this.id}).then(r=>{
                if (r.data.result === 0) {
                    let rData = r.data.data;
                    if(this.orderApplyId != '0'){
                        rData = rData.filter((d: any) => d.id == this.orderApplyId);
                    }

                    this.listData = rData;
                    let departs = [] as any;
                    rData.forEach((r: any) => {
                        departs.push({id: r.technicalDepartId, name: r.technicalDepartName});
                    });
                    this.departs = departs;
                    this.filterDepart();
                    this.load = true;
                }
            })
        }
        filterDepart(){
            let listData = this.listData;
            let list = [];
            if(this.departId != ""){
                list = listData.filter((d: any) => d.technicalDepartId == this.departId);
            }else{
                list = listData;
            }
            let instruments = [] as any;
            list.forEach((r: any) => {
                r.instruments.forEach((instrument: any) => {
                    instrument.departId = r.technicalDepartId;
                    instrument.departName = r.technicalDepartName
                });
                instruments = instruments.concat(r.instruments);
            });
            this.instruments = instruments;
        }
        //删除整个任务
        deleteBtn(){
            this.$confirm('确定要删除吗？此操作不可逆转。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                inspectionOrderApi.deleteOrder({id: this.id}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.closePage();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        // @Watch("$route.path")
        // get$routePath(){
        //     this.init();
        // }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }


        //0新增
        editExamine2(type: number) {
            const dataArr = this.allSelected as any;
            if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return;
            }
            if(dataArr.length > 1){
                this.$message.error("只能勾选一条");
                return;
            }
            const row = dataArr[0];
            this.instrumentsId = row.instrumentId?row.instrumentId:row.id;
            this.addExamineDialogBtn();
        }
        //检定列表模态框********************************************************
        //0新增  1编辑 2查看  3删除
        editExamine(type: number) {
            const dataArr = this.allSelectedExamine as any;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.delExamineBtn(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                this.editExamineDialogBtn(dataArr[0]);
            }else{
                this.addExamineDialogBtn();
            }
        }
        addExamineDialogBtn(){
            this.addExamineDialog = true;
            const form2Origin = JSON.parse(JSON.stringify(this.form2Origin));
            // form2Origin.checkResult = form2Origin.checkResult.value === 3 ? 0 : form2Origin.checkResult.value;
            this.form2 = Object.assign(form2Origin, {});
        }
        //编辑
        editExamineDialogBtn(data: any){
            const r = JSON.parse(JSON.stringify(data));
            this.addExamineDialog = true;
            r.checkResult = r.checkResult.value;
            r.basedRuleId = r.basedRuleId === 0 ? "" : r.basedRuleId;
            //影印件***********
            if(r.enclosure){
                this.fileList = [];
                try {
                    var obj=JSON.parse(r.enclosure);
                    if(typeof obj == 'object' && obj ){
                        for(let i = 0; i < obj.length; i++){
                            this.fileList.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                        }
                    }
                } catch(e) {
                    const arr = r.enclosure.split(",");
                    for(let i = 0; i < arr.length; i++){
                        this.fileList.push({name:"证书文件",url: imageUrl+arr[i]})
                    }
                }
            }else{
                this.fileList = [];
            }
            //影印件end******************
            this.form2 = Object.assign(JSON.parse(JSON.stringify(this.form2Origin)), r);
        }
        //删除
        delExamineBtn(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.certificationNumber).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                inspectionOrderApi.deleteInspectionOrderInstruments({ids: dataArr.flatMap((e:any)=>e.id).join(","), instrumentId: this.instrumentsId}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        const obj = this.instruments.find((e: any)=>e.instrumentId?e.instrumentId:e.id == this.instrumentsId) as any;
                        if(obj){
                            obj.examineNum -= dataArr.length;
                        }
                        this.handleClickExamine();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        handleClickExamine() {
            this.allSelectedExamine = [];
            let $table = this.$refs.tableExamine as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
            this.showExamineList2();
        }
        memberSelectExamine(selection: any, row: any) {
            this.allSelectedExamine = selection;
        }

        filterRules(keyword: string){
            if(keyword !=""){
                let key1 = ""; // 正则匹配出 [A-Z]+
                let key1s = /[A-Za-z]+/i.exec(keyword);
                if(key1s != null && key1s.length > 0){
                    key1 = key1s[0].toUpperCase();
                }

                let key2 = ""; //正则匹配出 \d+
                let key2s = /[\d-]+/i.exec(keyword);
                if(key2s != null && key2s.length > 0){
                    key2 = key2s[0];
                }

                let key3 = ""; //正则匹配出 常见汉字
                let key3s = /[\u4E00-\u9FFF]+/i.exec(keyword);
                if(key3s != null && key3s.length > 0){
                    key3 = key3s[0];
                }
                this.measuringRulesFilterd = this.measuringRules.filter((item: any) =>
                    (key1 == "" || item.number.toUpperCase().indexOf(key1) != -1)
                    && (key2 == "" || item.number.indexOf(key2) != -1)
                    && (key3 == "" || item.number.indexOf(key3) != -1)
                );
            }else{
                this.measuringRulesFilterd = [];
            }
        }

        getRules(){
            return rulesApi.page({current: -1}).then((r) => {
                if(r.data.result === 0){
                    this.measuringRules = r.data.data.records;
                }
            });
        }
        changeBasedRule(value: any){
            const rule = this.measuringRules.find((rule: any) => rule.id === value);
            this.form2.basedRuleName = rule.number + " " + rule.name;
        }
        getForm(){
            return {
                certificationNumber: "",   //证书编号
                certificateType: "",       //证书类型
                inspectionDate: "",        //检定日期
                expireDate: "",            //有效期
                checkCocn: "",             //检定结论
                checkResult: 1,           //检定状态
                resultText: "",                //检定结果
                basedRuleId: "",           //检定依据
                basedRuleName: "",         //检定依据名称
                reason: "",                //不合格原因
                checkPersonId: "",         //检定员id
                checkPersonName: "",       //检定员姓名
                checkPersonCardCode: "",   //检定员身份证号
                reApproverId: "",          //核验员id
                reApproverName: "",        //核验员姓名
                reApproverCardCode: "",    //核验员身份证号
                approverId: "",            //批准人id
                approverName: "",          //批准人名称
                approverCardCode: "",      //批准人身份证号
            }
        }
        //新增检定证书/结果
        onSubmit2() {
            //影印件****
            const enclosureList = this.fileList.map((e:any)=>{
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl,"")
                }
            })
            this.form2.enclosure = enclosureList.length === 0 ? "" :  JSON.stringify(enclosureList);
            //影印件end****
            let form = this.$refs.form2 as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    let params: any;
                    //如果未通过  则只存结果
                    if(this.form2.checkResult == 4){
                        params = {... this.getForm(), submitForm: 1};
                        params.id = this.form2.id;
                        params.checkResult = this.form2.checkResult;
                        params.resultText = this.form2.resultText;
                        params.instrumentId = this.form2.instrumentId;
                        params.expireDate = null;
                        params.inspectionDate = null;
                        params.basedRuleId = 0;
                    }else{
                        params = {...this.form2, submitForm: 1};
                        params.checkResult = this.form2.checkResult;
                    }
                    params = Object.assign(params, {instrumentsId: this.instrumentsId})
                    let api;
                    if(params.id){
                        api = inspectionOrderApi.updateInspectionOrderInstrumentsById(params);
                    }else{
                        api = inspectionOrderApi.updateInspectionOrderInstruments(params);
                    }
                    api.then(r=>{
                        if(r.data.result === 0){
                            this.$message.success("保存成功");
                            this.addExamineDialog = false;
                            if(!params.id){
                                const obj = this.instruments.find((e: any)=>e.instrumentId?e.instrumentId:e.id == this.instrumentsId) as any;
                                if(obj){
                                    obj.examineNum++;
                                }
                            }
                            if(this.examineNumDialog) {
                                this.handleClickExamine();
                            }
                        }
                    })
                }
            });
        }
        //检定列表模态框end********************************************************

        //上传检定结果复印件
        validateFile(){
            const enclosureList = this.fileList.map((e:any)=>{
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl,"")
                }
            })
            this.form2.enclosure = enclosureList.length === 0 ? "" :  JSON.stringify(enclosureList);
            const form = this.$refs.form2 as HTMLFormElement;
            if(form) {
                form.validateField('enclosure');
            }
        }
        //上传监控
        handleAvatarSuccess(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileList.push({name: "检定结果.pdf",url: imageUrl+rData});
                this.validateFile();
            }
        }
        handleRemove(file: any, fileList: any) {
            const index = this.fileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileList.splice(index, 1);
            }
            fileApi.deleteTemporaryFile({uuid: this.imgGuid})
            this.validateFile();
        }
        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if(fix == "pdf"){
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl,"") + "&name=" + file.name, '_blank');
            }
        }
        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }
        //上传监控
        beforeAvatarUpload(file: any) {
            const isPDF = file.type === 'application/pdf';

            if (!isPDF) {
                this.$message.error('上传图片只能是PDF格式!');
            }
            return (isPDF);
        }
        down(row: any) {
            try {
                var obj=JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=检定结果", '_blank');
                return false;
            }
        }
    }
